import axios from '../../axios-orders.js';
import * as actionTypes from './actionTypes.js'

export const orderSucess = (id, orderData) =>{
  
  return {
    type: actionTypes.ORDER_SUCCESS,
    id: id,
    orderData: orderData
  }
}

export const orderFailure = (err) =>{
  return {
    type: actionTypes.ORDER_FAILURE,
    err: err
  }
}

export const orderStart = () =>{
  return {
    type: actionTypes.ORDER_START
  }
}

export const orderPurchased = () =>{
  return {
    type: actionTypes.ORDER_PURCHASED_SUCCESSFULLY
  }
}

export const orderHandler = (orderData, token) =>{
  return dispatch =>{
    dispatch(orderStart());
    axios.post('/orders.json?auth='+ token, orderData)
        .then(response=>{
          console.log(response.data);
          return dispatch(orderSucess(response.id, response.data))
        })
        .catch(err=> {
          return dispatch(orderFailure(err))
        } );
  }

}

export const fetchOrderStart = () =>{
  return {
    type: actionTypes.FETCH_ORDER_START
  }
}

export const fetchOrderSuccess = (orders) =>{
  return {
    type: actionTypes.FETCH_ORDER_SUCCESS,
    orders: orders
  }
}

export const fetchOrderFail = (error) =>{
  return {
    type: actionTypes.FETCH_ORDER_FAIL,
    error: error
  }
}

export const fetchOrder  = (token, userId) =>{
  return dispatch =>{
    dispatch(fetchOrderStart());
    const queryParams = `?auth=${token}&orderBy="userId"&equalTo="${userId}"`;
    axios.get('/orders.json'+ queryParams)
      .then(response=>{
        
        let orders=[];

        for(let order in response.data){
          orders.push({...response.data[order], id: order});
        }

        return dispatch(fetchOrderSuccess(orders))
      })
      .catch(err=> dispatch(fetchOrderFail(err)))
  }
}

export const deleteOrder = (id , token) =>{
  return dispatch => {
    axios.delete(`/orders/${id}.json?auth=${token}`)
      .then(response =>
          dispatch(orderToBeDeleted(id))
        )
      .catch(err =>{
        alert('An error occured!');
      })
  }
}

export const orderToBeDeleted = (id) =>{
  return {
    type: actionTypes.DELETE_ORDER,
    id: id
  }
}





// WEBPACK FOOTER //
// ./src/store/actions/order.js